var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { useEffect, useState } from "react";
import * as ReactDOM from "react-dom";
import { HALDocTypes, HALGroupFields, HALSortFields, queryBuilder } from "./hal";
var Cite = require('citation-js');
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('div.wp-block-halb-hal-block').forEach(function (block) {
        ReactDOM.render(React.createElement(HALBlock, { desc: block.getAttribute('desc') == 'true', docTypes: block.getAttribute('docTypesStr').split(','), fq: block.getAttribute('fq'), groupField: block.getAttribute('groupField'), groupLimit: block.getAttribute('groupLimit'), portColl: block.getAttribute('portColl'), q: block.getAttribute('q'), sortField: block.getAttribute('sortField') }), block);
    });
});
function HALBlock(props) {
    var _a = useState(props.desc), desc = _a[0], setDesc = _a[1];
    var _b = useState(props.groupField), groupField = _b[0], setGroupField = _b[1];
    var _c = useState(props.sortField), sortField = _c[0], setSortField = _c[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(HALDiv, { blockProps: props, blockState: { desc: desc, groupField: groupField, sortField: sortField } })));
}
function HALHeader(_a) {
    var blockState = _a.blockState, setGroup = _a.setGroup, setSort = _a.setSort, setDesc = _a.setDesc;
    return (React.createElement("strong", null,
        React.createElement("span", null, "Sort by "),
        React.createElement("select", { value: blockState.sortField, onChange: function (event) { return setSort(event.target.value); } }, (function () {
            var options = [];
            Object.entries(HALSortFields).forEach(function (_a) {
                var key = _a[0], desc = _a[1];
                options.push(React.createElement("option", { value: key }, desc.toLowerCase()));
            });
            return options;
        })()),
        React.createElement("select", { value: blockState.desc ? 'desc' : 'asc', onChange: function (event) { return setDesc(event.target.value == 'desc'); } },
            React.createElement("option", { value: 'desc' }, "\u2193"),
            React.createElement("option", { value: 'asc' }, "\u2191")),
        React.createElement("span", null, " and group by "),
        React.createElement("select", { value: blockState.groupField, onChange: function (event) { return setGroup(event.target.value); } }, (function () {
            var options = [];
            Object.entries(HALGroupFields).forEach(function (_a) {
                var key = _a[0], desc = _a[1];
                options.push(React.createElement("option", { value: key }, desc.toLowerCase()));
            });
            return options;
        })())));
}
function HALDiv(props) {
    var _a = useState([]), groups = _a[0], setGroups = _a[1];
    var _b = useState(false), hasError = _b[0], setHasError = _b[1];
    var docTypes = props.blockProps.docTypes;
    function fetchGroups() {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, json, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        url = queryBuilder(__assign(__assign({}, props.blockProps), props.blockState));
                        return [4 /*yield*/, fetch(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        setGroups(json.grouped[Object.keys(json.grouped)[0]].groups);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        setHasError(true);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () { if (!hasError)
        fetchGroups(); }, [props]);
    if (hasError) {
        return React.createElement("p", { className: 'hal-error' }, "Something went wrong.");
    }
    var halGroups = [];
    groups.forEach(function (group) {
        if (/^\d+$/.test(group.groupValue) || docTypes.includes(group.groupValue)) {
            // halGroups.push(
            halGroups.unshift(React.createElement(HALGroup, { group: group, docTypes: docTypes }));
        }
    });
    return (React.createElement(React.Fragment, null, halGroups));
}
function HALGroup(_a) {
    var group = _a.group, docTypes = _a.docTypes;
    // Friendly name
    var groupName;
    if (docTypes.includes(group.groupValue)) {
        groupName = HALDocTypes[group.groupValue];
    }
    else {
        groupName = group.groupValue;
    }
    // Rows
    var rows = [];
    group.doclist.docs.forEach(function (doc) {
        if (docTypes.includes(doc.docType_s)) {
            rows.push(React.createElement(DocRow, { doc: doc }));
        }
    });
    // Keep group if there is at least one item
    if (rows.length == 0) {
        return React.createElement("div", null);
    }
    return (React.createElement("div", null,
        React.createElement("h3", null, groupName),
        React.createElement("ul", null, rows)));
}
function DocRow(_a) {
    var doc = _a.doc;
    var apa = new Cite(doc.label_bibtex).format('bibliography', {
        format: 'html',
        template: 'apa',
        lang: 'en-US'
    });
    return (React.createElement("li", null,
        React.createElement("div", { dangerouslySetInnerHTML: { __html: apa } }),
        React.createElement("a", { href: doc.uri_s, target: '_blank' }, "[Open HAL page in a new tab]")));
}
